import { E2EE_ALG } from './constants';

export type E2eeAlgorithm = typeof E2EE_ALG;

export type E2eeKeyRecord = {
  id: string;
  name: string;
  a: E2eeAlgorithm;
  k: string;
  createdAt: string;
};

export type E2eeHandshake = {
  k: string;
  a: E2eeAlgorithm;
};

export type E2eeEnvelope = {
  k: string;
  n: string;
  c: string;
};

export type E2eeCipher = {
  keyId: string;
  cryptoKey: CryptoKey;
  nextNonce: () => Uint8Array;
};

export function isE2eeEnvelope(value: unknown): value is E2eeEnvelope {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) return false;
  const o = value as Record<string, unknown>;
  return typeof o.k === 'string' && typeof o.n === 'string' && typeof o.c === 'string';
}

export function isE2eeKeyRecord(value: unknown): value is E2eeKeyRecord {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) return false;
  const o = value as Record<string, unknown>;
  return (
    typeof o.id === 'string' &&
    o.id.length > 0 &&
    typeof o.name === 'string' &&
    o.name.length > 0 &&
    o.a === E2EE_ALG &&
    typeof o.k === 'string' &&
    o.k.length > 0 &&
    typeof o.createdAt === 'string' &&
    o.createdAt.length > 0
  );
}
